// Compact, elegant energy label badge — uses official EU energy label colours.
const LABEL_COLORS = {
  "A+++": "#00643c",
  "A++": "#00913f",
  "A+": "#3aa42d",
  A: "#5ab436",
  B: "#c8d401",
  C: "#fcd200",
  D: "#fc9d00",
  E: "#fc7501",
  F: "#e74712",
  G: "#d11e1e",
};

export default function EnergyLabelBadge({ label = "A", size = "md", variant = "light" }) {
  const color = LABEL_COLORS[label] || LABEL_COLORS.A;

  const dims =
    size === "sm"
      ? "h-7 px-2.5 text-xs"
      : size === "lg"
      ? "h-12 px-5 text-lg"
      : "h-9 px-3.5 text-sm";

  return (
    <span
      data-testid={`energy-label-${label}`}
      className={`inline-flex items-center gap-2 font-medium tracking-wide ${dims}`}
      style={{
        backgroundColor: color,
        color: "#fff",
        clipPath: "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%)",
        paddingRight: size === "lg" ? "1.75rem" : "1.25rem",
      }}
    >
      <span className="overline" style={{ color: "rgba(255,255,255,0.85)", letterSpacing: "0.18em" }}>
        Energie
      </span>
      <span className="font-serif text-xl leading-none" style={{ fontSize: size === "lg" ? "1.6rem" : undefined }}>
        {label}
      </span>
    </span>
  );
}
